import React from 'react';
import CurrencyConversionTable from '../../../components/LocaleMasters/CurrencyConversion/CurrencyConversionTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <CurrencyConversionTable />
        </ContentView>
    );
};
export default index;
